import React from 'react';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { Divider } from '@mui/material';
import Tabla from './Tabla';
import CodeContent from './CodeContent';

import TablaTipoComprobante from './TablaTipoComprobante';
function createData(
  campo,
  Tipo,
  valorEjemplo,
  Descripcion
) {
  return { campo, Tipo, valorEjemplo, Descripcion };
}
const Detalle = () => {
  const [t] = useTranslation('global');

  const rows = [
    createData('ID',"long","0",t('content.datosDetalle.ID')),
    createData('ComprobanteID',"long","0",t('content.datosDetalle.ComprobanteID')),
    createData('Item',"int","1",t('content.datosDetalle.Item')),
    createData('ProductoCodigo',"string","Prod00151",t('content.datosDetalle.ProductoCodigo')),
    createData('ProductoCodigoCliente',"string","UBI2023",t('content.datosDetalle.ProductoCodigoCliente')),
    createData('ProductoCodigoSUNAT',"string","39121321",t('content.datosDetalle.ProductoCodigoSUNAT')),
    createData('TipoSistemaISCCodigo',"string","\n -01 Sistema al valor \n -02 Aplicación del monto fijo \n -03 Sistema de precios de Venta al Público",t('content.datosDetalle.TipoSistemaISCCodigo')),    createData('UnidadMedidaCodigo',"string","valor",t('content.datosDetalle.UnidadMedidaCodigo')),
    createData('PrecioUnitarioItem',"decimal","236",t('content.datosDetalle.PrecioUnitarioItem')),
    createData('PrecioVentaCodigo',"string","0 o 1",t('content.datosDetalle.PrecioVentaCodigo')),
    createData('ICBPER',"decimal","0.5",t('content.datosDetalle.ICBPER')),
    createData('DescuentoIndicador',"string","0 o 1",t('content.datosDetalle.DescuentoIndicador')),
    createData('PercepcionPorcentaje',"decimal","0",t('content.datosDetalle.PercepcionPorcentaje')),
    createData('PrecioCompra',"decimal","50",t('content.datosDetalle.PrecioCompra')),
    createData('CantidadUnidadMedida',"decimal","1",t('content.datosDetalle.CantidadUnidadMedida')),
    createData('Kit',"bool","true",t('content.datosDetalle.Kit')),
    createData('PrecioUnitarioNeto',"decimal","150",t('content.datosDetalle.PrecioUnitarioNeto')),
    createData('Cargo',"decimal","18.4375",t('content.datosDetalle.Cargo')),
    createData('Descuento',"decimal","40",t('content.datosDetalle.Descuento')),
    createData('ValorUnitario',"decimal","200",t('content.datosDetalle.ValorUnitario')),
    createData('ValorUnitarioNeto',"decimal","127.118",t('content.datosDetalle.ValorUnitarioNeto')),
    createData('ValorVentaItem',"decimal","127.118",t('content.datosDetalle.ValorVentaItem')),
    createData('ValorVentaItemXML',"decimal","127.118",t('content.datosDetalle.ValorVentaItemXML')),
    createData('ISC',"decimal","39.996399",t('content.datosDetalle.ISC')),
    createData('IGV',"decimal","18",t('content.datosDetalle.IGV')),
    createData('ICBPERSubTotal',"decimal","1",t('content.datosDetalle.ICBPERSubTotal')),
    createData('DescuentoBase',"decimal","400",t('content.datosDetalle.DescuentoBase')),
    createData('CargoItem',"decimal","36.875",t('content.datosDetalle.CargoItem')),
    createData('PrecioVenta',"decimal","472",t('content.datosDetalle.PrecioVenta')),
    createData('MontoTributo',"decimal","66.375",t('content.datosDetalle.MontoTributo')),
    createData('ISCPorcentaje',"decimal","11.11",t('content.datosDetalle.ISCPorcentaje')),
    createData('CargoPorcentaje',"decimal","10",t('content.datosDetalle.CargoPorcentaje')),
    createData('Descripcion',"string","PRODUCTO GRAVADO",t('content.datosDetalle.Descripcion')),
    createData('Observacion',"string","Regularización del anticipo",t('content.datosDetalle.Observacion')),
    createData('Stock',"decimal","5",t('content.datosDetalle.Stock')),
    createData('Cantidad',"decimal","2",t('content.datosDetalle.Cantidad')),
    createData('PrecioCodigo',"decimal","535",t('content.datosDetalle.PrecioCodigo')),
    createData('PrecioUnitario',"decimal","236",t('content.datosDetalle.PrecioUnitario')),
    createData('Peso',"decimal","1",t('content.datosDetalle.Peso')),
    createData('DescuentoMonto',"decimal","23.6",t('content.datosDetalle.DescuentoMonto')),
    createData('DescuentoPorcentaje',"decimal","10",t('content.datosDetalle.DescuentoPorcentaje')),
    createData('TipoAfectacionIGVCodigo',"string","10 Gravado – Operación Onerosa",t('content.datosDetalle.TipoAfectacionIGVCodigo')),
    createData('ValorVenta',"decimal","400",t('content.datosDetalle.ValorVenta')),
    createData('ImporteTotal',"decimal","472",t('content.datosDetalle.ImporteTotal')),
    createData('PesoTotal',"decimal","1",t('content.datosDetalle.PesoTotal'))
   ];

  const datos =
    `
    {
        "ID": 0,
        "ComprobanteID": 0,
        "Item": 1,
        "ProductoCodigo": "Prod00066",
        "ProductoCodigoCliente": "Prod00066",
        "ProductoCodigoSUNAT": "39121321",
        "TipoSistemaISCCodigo": "00",
        "UnidadMedidaCodigo": "NIU",
        "PrecioUnitarioItem": 118,
        "PrecioVentaCodigo": "01",
        "ICBPER": 0,
        "DescuentoIndicador": 0,
        "PercepcionPorcentaje": 0,
        "PrecioCompra": 1.18,
        "CantidadUnidadMedida": 1,
        "Kit": false,
        "PrecioUnitarioNeto": 118,
        "Cargo": 0,
        "Descuento": 0,
        "ValorUnitario": 100,
        "ValorUnitarioNeto": 100,
        "ValorVentaItem": 100,
        "ValorVentaItemXML": 100,
        "ISC": 0,
        "IGV": 18,
        "ICBPERSubTotal": 0,
        "DescuentoBase": 100,
        "CargoItem": 0,
        "PrecioVenta": 118,
        "MontoTributo": 18,
        "ISCPorcentaje": 0,
        "CargoPorcentaje": 0,
        "Descripcion": "TECLADO GRAVADO1",
        "Observacion": "",
        "Stock": 180,
        "Cantidad": 1,
        "PrecioCodigo": 1444,
        "PrecioUnitario": "118",
        "Peso": 1,
        "DescuentoMonto": 0,
        "DescuentoPorcentaje": 0,
        "TipoAfectacionIGVCodigo": "10",
        "ValorVenta": 100,
        "ImporteTotal": 118,
        "PesoTotal": 1

  }
    `;
  const respuestaFactura =
    `
    {
      "xml_pdf": {
          "IDComprobante": 92869,
          "Codigo": 0,
          "IDRepositorio": "zLEExc3lbkCwIHcvtuP2JA==",
          "Firma": "nLpw2MXleQkyw/223CVZTOvqUQ0=",
          "Mensaje": "01-F002-1916"
      },
      "cdr": {
          "IDComprobante": 92869,
          "Codigo": 0,
          "IDRepositorio": "19001164",
          "Firma": "",
          "Mensaje": "La Factura numero F002-1916, ha sido aceptada"
        }
    }       
    `
  ;
  const respuestaBoleta =
    `
    {
      "xml_pdf": {
          "IDComprobante": 92865,
          "Codigo": 0,
          "IDRepositorio": "SspjOsVXeHELV0s1yaRbWA==",
          "Firma": "2Yol66hI6dfH3Tb9rboKcCQruPw=",
          "Mensaje": "03-B001-5068"
      },
      "cdr": {
          "IDComprobante": 92865,
          "Codigo": 0,
          "IDRepositorio": "19005261",
          "Firma": "",
          "Mensaje": "La Boleta numero B001-5068, ha sido aceptada"
      }
    }
    `
  ;
  const respuestaNotaCredito =
    `
    {
      "xml_pdf": {
          "IDComprobante": 92883,
          "Codigo": 0,
          "IDRepositorio": "jFquFm7dclZN+Rruzckx6A==",
          "Firma": "p05W/m+XXnwvxTe+JE3pFcMWfig=",
          "Mensaje": "07-FC01-1133"
      },
      "cdr": {
          "IDComprobante": 92883,
          "Codigo": 0,
          "IDRepositorio": "19005277",
          "Firma": "",
          "Mensaje": "La Nota de Credito numero FC01-1133, ha sido aceptada"
      }
    }
    
    `
  ;
  const respuestaNotaDebito =
    `
    {
      "xml_pdf": {
          "IDComprobante": 92884,
          "Codigo": 0,
          "IDRepositorio": "IrkEoS/xXN9nRu8DbjJvfw==",
          "Firma": "sV3TL8VnYRPyEvIZb9MHcnwjopY=",
          "Mensaje": "08-FD01-101"
      },
      "cdr": {
          "IDComprobante": 92884,
          "Codigo": 0,
          "IDRepositorio": "19005278",
          "Firma": "",
          "Mensaje": "La Nota de Debito numero FD01-101, ha sido aceptada"
      }
    }
    
    `
  ;
  return (
    <div id='detalle'>
      <Divider sx={{ height: '70px' }} />
      <Typography variant="h3" id="detalleObjeto" gutterBottom>
        {t('content.detalle.titulo')}
      </Typography>
      <Typography variant="h5" gutterBottom>
        {t('content.detalle.subtituloObjeto')}
      </Typography>
      <CodeContent code={datos} />  
      <br id={"detalleDescripcion"}/>
      <br/>
      <br/>
      <Typography variant="h5" gutterBottom>
        {t('content.detalle.subtituloTabla')}
      </Typography>
      <Tabla rows={rows}/>
      <br/>
      <Typography variant="h5" gutterBottom>
        {t('content.notaCredito.subtituloRespuesta')}
      </Typography>
      <Typography variant="body1" id="NotaCredito" gutterBottom>
        {t('content.notaCredito.respuesta')}
      </Typography>

      <TablaTipoComprobante Factura={respuestaFactura} NombreFactura={t('content.factura.titulo')} Boleta={respuestaBoleta} NombreBoleta={t('content.boleta.titulo')} NotaCredito={respuestaNotaCredito} NombreNotaCredito={t('content.notaCredito.titulo')} NotaDebito={respuestaNotaDebito} NombreNotaDebito={t('content.notaDebito.titulo')}></TablaTipoComprobante>
      {/*<CodeContent code={respuestaFactura} />*/}
    </div>
  );
}
export default Detalle